import { ConsolidatedLocationView, EventPersonDto, EventVehicleDto } from '@mark43/cad-api';
import { observer } from 'mobx-react';
import { useRelatedData } from '../../../related-data/use-related-data';
import { RelatedDataTabContent } from './related-data-tab-content';

export const RelatedDataTabContentExistingEvent = observer(
    function RelatedDataTabContentExistingEvent(props: {
        phoneNumbers: string[];
        vehicles: EventVehicleDto[];
        location?: ConsolidatedLocationView;
        reportingParties: EventPersonDto[];
    }) {
        const { viewMoreCadEvents, viewMoreRmsReports, viewMoreVehicles } = useRelatedData();

        return (
            <RelatedDataTabContent
                {...props}
                onViewMoreCadEvents={() => {
                    viewMoreCadEvents({
                        isNewEvent: false,
                    });
                }}
                onViewMoreRmsReports={() => {
                    viewMoreRmsReports({
                        isNewEvent: false,
                    });
                }}
                onViewMoreVehicles={() => {
                    viewMoreVehicles({
                        isNewEvent: false,
                    });
                }}
            />
        );
    }
);
